// extracted by mini-css-extract-plugin
export var backdropBlur = "_mf-0";
export var contentCard = "_mf-5";
export var frame = "_mf-2";
export var image = "_mf-4";
export var imagePane = "_mf-3";
export var modal = "_mf-1";